import {
	type RouteResource,
	type RouterContext,
	createResource,
} from '@atlassian/react-resource-router';

const PRODUCT_JSM_ORGANIZATION_MEMBERS = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

const TEN_SECONDS_IN_MILLIS = 1000 * 10;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const productsJsmOrganizationMembersResource: RouteResource<any> = createResource<any>({
	type: PRODUCT_JSM_ORGANIZATION_MEMBERS,
	getKey: (routerContext: RouterContext) =>
		`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-products-jsm-organization-members", jiraSpaEntry: "async-resource-products-jsm-organization-members" */ './organizationMembersFetch.tsx'
		),
	maxAge: TEN_SECONDS_IN_MILLIS,
});
